import React from 'react';

import porductBottomSide from '../../../main/assets/images/lapRf/immersionrc-lap-rf-top-side.webp';

export const Specifications = () => {
  return (
    <section className="laprf-specifications">
      <div className="laprf-specifications-bg" />
      <div className="laprf-specifications-text-layout">
        <div className="laprf-specifications-text-container">
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">weight</h3>
            <p className="laprf-specifications-text-description">1.59 KG</p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">dimensions</h3>
            <p className="laprf-specifications-text-description">
              220 mm (L) × 160 mm (W) × 30 mm (H)
            </p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">power</h3>
            <p className="laprf-specifications-text-description">
              DC input: 10–20 V
            </p>
            <p className="laprf-specifications-text-description">
              (3S–4S LiPo or equivalent DC power supply)
            </p>
            <p className="laprf-specifications-text-description">
              Power Over Ethernet (PoE) 802.3at
            </p>
          </div>
        </div>
        <div className="laprf-specifications-text-container">
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">antenna Type</h3>
            <p className="laprf-specifications-text-description">
              Custom RHCP / LHCP / Linear
            </p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">
              Supported Pilots
            </h3>
            <p className="laprf-specifications-text-description">
              1 to 8 pilots with maximum precision
            </p>
            <p className="laprf-specifications-text-description">
              Up to 16 pilots with 50% precision
            </p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">
              Connectivity Ports
            </h3>
            <p className="laprf-specifications-text-description">
              RJ-45 Ethernet (on flying lead)
            </p>
            <p className="laprf-specifications-text-description">
              Wired USB (internal access)
            </p>
          </div>
        </div>
        <div className="laprf-specifications-text-container">
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">upc</h3>
            <p className="laprf-specifications-text-description">
              840630182161
            </p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">
              Supported Channels
            </h3>
            <p className="laprf-specifications-text-description">
              All common and select rare frequencies
            </p>
            <p className="laprf-specifications-text-description">Analog</p>
            <p className="laprf-specifications-text-description">
              Digital 5.8GHz
            </p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">License</h3>
            <p className="laprf-specifications-text-description">
              Perpetual license – no install required, no time limits, no remote
              access dependencies
            </p>
          </div>
        </div>
        <div className="laprf-specifications-text-container">
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">
              Video Format Compatibility
            </h3>
            <p className="laprf-specifications-text-description">
              Analog (4:3 / 16:9 switchable)
            </p>
            <p className="laprf-specifications-text-description">
              Digital 5.8 GHz
            </p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">
              PC Software Compatibility
            </h3>
            <p className="laprf-specifications-text-description">
              Livetime FPV
            </p>
          </div>
          <div className="laprf-specifications-text-section">
            <h3 className="laprf-specifications-text-title">user interface</h3>
            <p className="laprf-specifications-text-description">
              Easy IP address configuration
            </p>
            <p className="laprf-specifications-text-description">
              Integrated OLED with button-based UI
            </p>
          </div>
        </div>
      </div>
      <img
        src={porductBottomSide}
        alt="Side Top View of the LapRF"
        className="laprf-specifications-product"
      />
    </section>
  );
};
